import { eventsCalendarAtom } from "components/investorrelations/atoms";
import { useAtomValue, useSetAtom } from "jotai";

export const useEventsCalendarValue = () => useAtomValue(eventsCalendarAtom);
export const useEventsCalendarSet = () => useSetAtom(eventsCalendarAtom);
